module.exports = __webpack_public_path__ + "static/media/glafka.fdda3ea3.png";